import { createGlobalStyle } from "styled-components";
import colors from "./colors.js";
import mediaQuery from "./mediaQuery.js";
const GlobalStyle = createGlobalStyle` main {}


* {
	margin: 0;
	padding: 0;
	font-family: "neue-haas-grotesk-text", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
	font-weight: 400;
	font-display: swap;
	font-size: 1.4rem;
	color: ${colors.white};
	text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	font-weight: lighter;
	border: none;
    box-sizing: border-box;
	@media (min-width: 1440px) {
	}
}

div[data-placeholder-image] {
	background-color: transparent !important;
}


html {

	font-size: 62.5%;
	@media (min-width: 1730px) {
		font-size: 0.578vw;
		font-size: clamp(62.5%, .578vw, 75%);
	}
}

body {

	background-color: ${colors.dark}
}

p{
	color: inherit;
	font-size: 1.4rem;
	line-height: 1;

}

* {
font-size: inherit;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	color: inherit;
	font-size: 1.6rem;
	font-family: 'Trash', sans-serif;
}

span{
	font-size: inherit;
	font-family: inherit;
	font-weight: inherit;
	line-height: inherit;
	color: inherit;
}

strong {}

button {
	border: none;
	margin: 0;
	padding: 0;
	width: auto;
	overflow: visible;
	background: transparent;
	color: inherit;
	font: inherit;
	line-height: normal;
	-webkit-font-smoothing: inherit;
	-moz-osx-font-smoothing: inherit;
	-webkit-appearance: none;


}


::selection {
	background-color: ${colors.purple};
	color: ${colors.dark};

}

::-moz-selection {
	background-color: ${colors.dark};
	color: ${colors.purple};
}



`;

export default GlobalStyle;
